import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { PATH } from '../../../constants/path';
import { PAGE_DIRECTORY } from '../../../services/filter/constants';
import { reductionDirectoryRoutes } from '../../../routes/directory';

import { clearFilter, clearSort, sortPartnerOnNbCoupon } from '../../../services/filter/actions';

import { mapRoutes } from '../../../utils/routeUtils';

import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

class ReductionDirectoryPage extends React.Component {
    componentDidMount() {
        this.props.sortPartnerOnNbCoupon(PAGE_DIRECTORY);
    }

    componentWillUnmount() {
        this.props.clearFilter(PAGE_DIRECTORY);
        this.props.clearSort(PAGE_DIRECTORY);
    }

    render() {
        return (
            <div>
                <LocalizedBreadcrumbItem to={PATH.REDUCTION_PATH}>
                    {this.props.i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <Switch>{mapRoutes(reductionDirectoryRoutes)}</Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.DIRECTORY.REDUCTION
    };
};

const mapDispatchToProps = {
    clearFilter,
    clearSort,
    sortPartnerOnNbCoupon
};

export default connect(mapStateToProps, mapDispatchToProps)(ReductionDirectoryPage);



// WEBPACK FOOTER //
// ./src/components/pages/directory/ReductionDirectoryPage.js